import { useQuery } from '@tanstack/react-query';
import { massMigrationApi, massMigrationKeys } from '@/lib/api/massMigration';

export function useMassMigrationBatches() {
  return useQuery({
    queryKey: massMigrationKeys.batches(),
    queryFn: () => massMigrationApi.getBatches(),
    refetchInterval: 15_000,
  });
}

export function useMassMigrationBatch(id: string, isLive: boolean) {
  return useQuery({
    queryKey: massMigrationKeys.batch(id),
    queryFn: () => massMigrationApi.getBatch(id),
    refetchInterval: isLive ? 5_000 : false,
  });
}

export function useMassMigrationBatchAuto(id: string) {
  return useQuery({
    queryKey: massMigrationKeys.batch(id),
    queryFn: () => massMigrationApi.getBatch(id),
    refetchInterval: (query) => {
      const data = query.state.data;
      const status = data?.status;
      if (status === 'InProgress' || status === 'Pending') return 5_000;
      // Keep polling (slower) while deferred invites are still draining — the batch is
      // already terminal by then, so status alone would stop the refresh too early, and
      // a large batch can drain for hours at 50 invites/min.
      return (data?.invitesPending ?? 0) > 0 ? 15_000 : false;
    },
  });
}
